module.exports = __webpack_public_path__ + "img/engineeringCases1.98740984.png";